/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ArticleResponseType } from '../models/article-response-type';
import { ArticlesResponse } from '../models/articles-response';
import { checkArticle } from '../fn/articles/check-article';
import { CheckArticle$Params } from '../fn/articles/check-article';
import { editArticleAdd } from '../fn/articles/edit-article-add';
import { EditArticleAdd$Params } from '../fn/articles/edit-article-add';
import { editArticleAttributes } from '../fn/articles/edit-article-attributes';
import { EditArticleAttributes$Params } from '../fn/articles/edit-article-attributes';
import { editArticleRemove } from '../fn/articles/edit-article-remove';
import { EditArticleRemove$Params } from '../fn/articles/edit-article-remove';
import { getDeliveryNoteArticles } from '../fn/articles/get-delivery-note-articles';
import { GetDeliveryNoteArticles$Params } from '../fn/articles/get-delivery-note-articles';
import { postDeliveryNoteArticles } from '../fn/articles/post-delivery-note-articles';
import { PostDeliveryNoteArticles$Params } from '../fn/articles/post-delivery-note-articles';
import { removeArticle } from '../fn/articles/remove-article';
import { RemoveArticle$Params } from '../fn/articles/remove-article';

@Injectable({ providedIn: 'root' })
export class ArticlesService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getDeliveryNoteArticles()` */
  static readonly GetDeliveryNoteArticlesPath = '/organization-sites/{organizationSiteKey}/delivery-notes/{deliveryNoteKey}/articles';

  /**
   * Get all articles of a delivery note.
   *
   * Returns all articles of a delivery note.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getDeliveryNoteArticles()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDeliveryNoteArticles$Response(params: GetDeliveryNoteArticles$Params, context?: HttpContext): Observable<StrictHttpResponse<ArticlesResponse>> {
    const obs = getDeliveryNoteArticles(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get all articles of a delivery note.
   *
   * Returns all articles of a delivery note.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getDeliveryNoteArticles$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDeliveryNoteArticles(params: GetDeliveryNoteArticles$Params, context?: HttpContext): Observable<ArticlesResponse> {
    const resp = this.getDeliveryNoteArticles$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ArticlesResponse>): ArticlesResponse => r.body)
    );
  }

  /** Path part for operation `postDeliveryNoteArticles()` */
  static readonly PostDeliveryNoteArticlesPath = '/organization-sites/{organizationSiteKey}/consignor/delivery-notes/{deliveryNoteKey}/articles';

  /**
   * Add articles data to a delivery note.
   *
   * Add articles data to an existing delivery note.
   * The delivery note can not be in a bundle with status sent or closed.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postDeliveryNoteArticles()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postDeliveryNoteArticles$Response(params: PostDeliveryNoteArticles$Params, context?: HttpContext): Observable<StrictHttpResponse<ArticlesResponse>> {
    const obs = postDeliveryNoteArticles(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Add articles data to a delivery note.
   *
   * Add articles data to an existing delivery note.
   * The delivery note can not be in a bundle with status sent or closed.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postDeliveryNoteArticles$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postDeliveryNoteArticles(params: PostDeliveryNoteArticles$Params, context?: HttpContext): Observable<ArticlesResponse> {
    const resp = this.postDeliveryNoteArticles$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ArticlesResponse>): ArticlesResponse => r.body)
    );
  }

  /** Path part for operation `removeArticle()` */
  static readonly RemoveArticlePath = '/organization-sites/{organizationSiteKey}/consignor/delivery-notes/{deliveryNoteKey}/articles/{articleKey}';

  /**
   * Removes an article.
   *
   * Removes an article from a delivery note.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `removeArticle()` instead.
   *
   * This method doesn't expect any request body.
   */
  removeArticle$Response(params: RemoveArticle$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = removeArticle(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Removes an article.
   *
   * Removes an article from a delivery note.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `removeArticle$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  removeArticle(params: RemoveArticle$Params, context?: HttpContext): Observable<void> {
    const resp = this.removeArticle$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `editArticleRemove()` */
  static readonly EditArticleRemovePath = '/organization-sites/{organizationSiteKey}/consignee/articles/{articleKey}/edit';

  /**
   * Removes an article as an edit.
   *
   * Removes an article from an delivery note as an edit. The removed deliveryNote can still be retrieved, but is marked as editedRemoved.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `editArticleRemove()` instead.
   *
   * This method doesn't expect any request body.
   */
  editArticleRemove$Response(params: EditArticleRemove$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = editArticleRemove(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Removes an article as an edit.
   *
   * Removes an article from an delivery note as an edit. The removed deliveryNote can still be retrieved, but is marked as editedRemoved.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `editArticleRemove$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  editArticleRemove(params: EditArticleRemove$Params, context?: HttpContext): Observable<void> {
    const resp = this.editArticleRemove$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `editArticleAttributes()` */
  static readonly EditArticleAttributesPath = '/organization-sites/{organizationSiteKey}/consignee/articles/{articleKey}/edit';

  /**
   * Edit partially attributes of an article.
   *
   * Edit partially attributes of an article, e.g. gtin or pos. This original article attributes will not be deleted.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `editArticleAttributes()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  editArticleAttributes$Response(params: EditArticleAttributes$Params, context?: HttpContext): Observable<StrictHttpResponse<ArticleResponseType>> {
    const obs = editArticleAttributes(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Edit partially attributes of an article.
   *
   * Edit partially attributes of an article, e.g. gtin or pos. This original article attributes will not be deleted.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `editArticleAttributes$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  editArticleAttributes(params: EditArticleAttributes$Params, context?: HttpContext): Observable<ArticleResponseType> {
    const resp = this.editArticleAttributes$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ArticleResponseType>): ArticleResponseType => r.body)
    );
  }

  /** Path part for operation `editArticleAdd()` */
  static readonly EditArticleAddPath = '/organization-sites/{organizationSiteKey}/consignee/delivery-notes/{deliveryNoteKey}/articles/edit';

  /**
   * Adds a new article as an edit.
   *
   * Adds a new article as an edit. The added article can be retrieved with the other articles, but is marked as editedAdded.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `editArticleAdd()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  editArticleAdd$Response(params: EditArticleAdd$Params, context?: HttpContext): Observable<StrictHttpResponse<ArticlesResponse>> {
    const obs = editArticleAdd(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Adds a new article as an edit.
   *
   * Adds a new article as an edit. The added article can be retrieved with the other articles, but is marked as editedAdded.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `editArticleAdd$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  editArticleAdd(params: EditArticleAdd$Params, context?: HttpContext): Observable<ArticlesResponse> {
    const resp = this.editArticleAdd$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ArticlesResponse>): ArticlesResponse => r.body)
    );
  }

  /** Path part for operation `checkArticle()` */
  static readonly CheckArticlePath = '/organization-sites/{organizationSiteKey}/consignee/articles/{articleKey}/check';

  /**
   * Check or uncheck an article.
   *
   * Check or uncheck an article. It can be used to mark that an article was successfully processed.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `checkArticle()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  checkArticle$Response(params: CheckArticle$Params, context?: HttpContext): Observable<StrictHttpResponse<ArticleResponseType>> {
    const obs = checkArticle(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Check or uncheck an article.
   *
   * Check or uncheck an article. It can be used to mark that an article was successfully processed.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `checkArticle$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  checkArticle(params: CheckArticle$Params, context?: HttpContext): Observable<ArticleResponseType> {
    const resp = this.checkArticle$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ArticleResponseType>): ArticleResponseType => r.body)
    );
  }

}
